import { render, staticRenderFns } from "./LinkGoogleAccount.vue?vue&type=template&id=c716ce50&"
import script from "./LinkGoogleAccount.vue?vue&type=script&lang=js&"
export * from "./LinkGoogleAccount.vue?vue&type=script&lang=js&"
import style0 from "./LinkGoogleAccount.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports